/**
 * @file index.tsx
 *
 * @fileoverview Renders button for sharing on WhatsApp.
 */

import {
  SharingButtonProps,
  SharingButtonCustom,
} from '~/jobiqo/components/SocialMedia/SharingButtons/components/Custom';
import WhatsappColorIcon from '~/vcl/icons/color/Whatsapp';
import { FormattedMessage } from 'react-intl';
import WhatsappIcon from '~/vcl/icons/Whatsapp';

export default function WhatsAppSharingButton({
  url,
  coloredIcons = true,
  ...props
}: SharingButtonProps) {
  return (
    <SharingButtonCustom
      text={
        <FormattedMessage
          id="social_media_sharing_buttons_whatsapp"
          defaultMessage="on WhatsApp"
        />
      }
      urlToShare={url}
      href="https://wa.me/?text="
      IconComponent={coloredIcons ? WhatsappColorIcon : WhatsappIcon}
      {...props}
    />
  );
}
export { WhatsAppSharingButton };
